import { render, staticRenderFns } from "./ProofOfClassHours.vue?vue&type=template&id=2fff596a&scoped=true"
import script from "./ProofOfClassHours.vue?vue&type=script&lang=js"
export * from "./ProofOfClassHours.vue?vue&type=script&lang=js"
import style0 from "./ProofOfClassHours.vue?vue&type=style&index=0&id=2fff596a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fff596a",
  null
  
)

export default component.exports